import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { localized } from "../../common/utils";

export function PersonnelStats({ persons }) {
  const { t } = useTranslation();
  const [text, setText] = useState();

  useEffect(() => {
    if (!persons) return;

    if (persons.length === 0) {
      setText(t("NoPersonsFound", "Ei henkilöitä listalla"));
      return;
    }

    const activePersons = persons.filter(
      p => !p.employmentDetails?.endDate
    );

    const total = activePersons.length;

    const genderPersons = activePersons.filter(p => p.socSec);
    const male = genderPersons.filter(
      p => (p.gender || "").trim().toUpperCase() === "M"
    ).length;

    const female = genderPersons.filter(
      p => (p.gender || "").trim().toUpperCase() === "N"
    ).length;

    const today = new Date();

    const fourMonthsAgo = new Date();
    fourMonthsAgo.setMonth(fourMonthsAgo.getMonth() - 4);

    const startedLast4Months = activePersons.filter(p => {
      const sd = p.employmentDetails?.startDate
        ? new Date(p.employmentDetails.startDate)
        : null;
      return sd && sd >= fourMonthsAgo && sd <= today;
    });

    const endedContracts = persons.filter(
      p => p.employmentDetails?.endDate && p.employmentDetails.endDate.trim() !== ""
    );

    const upcomingStarts = activePersons
      .map(p => ({
        ...p,
        start: p.employmentDetails?.startDate
          ? new Date(p.employmentDetails.startDate)
          : null,
      }))
      .filter(p => p.start && p.start > today)
      .sort((a, b) => a.start - b.start);

    const nextStart = upcomingStarts[0];

    const lastStarted = activePersons
      .map(p => ({
        ...p,
        start: p.employmentDetails?.startDate
          ? new Date(p.employmentDetails.startDate)
          : null,
      }))
      .filter(p => p.start && p.start <= today)
      .sort((a, b) => b.start - a.start)[0];

    const nextStartText = nextStart
      ? t(
          "NextStart",
          "Seuraava aloittava työntekijä on {{name}}, aloituspäivä {{date}}.",
          {
            name: `${nextStart.forename} ${nextStart.surname}`,
            date: nextStart.start.toLocaleDateString(localized.resolvedLanguage),
          }
        )
      : t("NoNextStart", "Seuraavia aloituksia ei ole tiedossa.");

    const lastStartedText = lastStarted
      ? t(
          "LastStarted",
          "Viimeksi meille palkattiin {{name}}, aloituspäivä {{date}}.",
          {
            name: `${lastStarted.forename} ${lastStarted.surname}`,
            date: lastStarted.start.toLocaleDateString(localized.resolvedLanguage),
          }
        )
      : t("NoLastStarted", "Aiemmin palkattuja ei ole tiedossa.");

    setText(
      t(
        "PersonnelStatsFull",
        "Palkkalistoillamme on yhteensä {{total}} henkilöä, joista {{male}} on miehiä ja {{female}} naisia. {{nextStart}} {{lastStarted}} Viimeisen neljän kuukauden aikana meillä on aloittanut {{started}} työntekijää, ja päättyneitä työsuhteita on ollut {{ended}}.",
        {
          total,
          male,
          female,
          nextStart: nextStartText,
          lastStarted: lastStartedText,
          started: startedLast4Months.length,
          ended: endedContracts.length,
        }
      )
    );
  }, [persons, t]);

  return text ? (
    <div className="p-3">
      <h4 style={{ color: "var(--heeros-blue)", marginBottom: "15px" }}>
        {t("PersonnelStatistics", "Henkilöstötilastot")}
      </h4>
      <div>{text}</div>
    </div>
  ) : (
    <LoadingContainer />
  );
}